export default __webpack_public_path__ + "static/media/inventMgmt2.793390f0.png";